module.exports = __webpack_public_path__ + "img/public_filetype_image_normal.e5c13b05.svg";